export const contactsTableHeader = () => {
  return [
    {
      name: "Email",
      field: "email",
      align: "left",
      sorting: false,
    },
    {
      name: "Name",
      field: "name",
      align: "left",
    },
    {
      name: "Status",
      field: "status",
      align: "left",
      sorting: false,
    },
    {
      name: "Created On",
      field: "createdOn",
      align: "left",
      sorting: false,
    },
    {
      name: "Action",
      field: "action",
      align: "left",
      sorting: false,
      hide: true,
    },
  ];
};

export const contactsOptions = [
  {
    label: "All Contacts",
    value: "all",
  },
  {
    label: "Team's Contacts",
    value: "team",
  },
  {
    label: "My Contacts",
    value: "my",
  },
];

export const contactsStatusOptions = [
  {
    label: "All status",
    value: -1,
  },
  {
    label: "Subscribed",
    value: 1,
  },
  {
    label: "Unsubscribed",
    value: 0,
  },
];

export const getContactStatus = (status: number) => {
  if (status === 0) {
    return "Unsubscribed";
  }
  if (status === 1) {
    return "Subscribed";
  }
};

export const getSenderStatus = (status: number) => {
  if (status === 0) {
    return "Not verified";
  }
  if (status === 1) {
    return "Verified";
  }
};

export const MoreActionsMenu = (moreOptions: { status: number }) => {
  const isSubscribed = moreOptions.status === 1;
  const menuItems = [
    {
      label: "Delete",
      value: "delete",
    },
    {
      label: isSubscribed ? "Unsubscribe" : "Subscribe",
      value: isSubscribed ? "unsubscribe" : "subscribe",
    },
  ];
  if (moreOptions.status === 2 || moreOptions.status === 3) {
    return [
      {
        label: "Delete",
        value: "delete",
      },
    ];
  }
  return menuItems;
};

export const StatusColors = {
  0: "#5a5f73",
  1: "#3cad44",
  2: "#d72727",
  3: "#ff7c2e",
  4: "#9f9fad",
} as { [key: number]: string };
